module.exports = __webpack_public_path__ + "static/media/mic.5ed3f31a.svg";